/**
 * Service with several helper functions to be available in the whole app.
 */
export class IdLabelStruct {
  constructor(
    public id: any,
    public label: string
  ) {};
}
